import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/database';
import 'firebase/compat/analytics';

import configJson from '../../files/config.json';

const { REACT_APP_FIREBASE_PROJECT } = process.env;
const configs = JSON.parse(atob(configJson.config));

const firebaseConfig = configs[REACT_APP_FIREBASE_PROJECT || 'p100-001'];
const app = firebase.initializeApp(firebaseConfig);

export const Auth = app.auth();
export const DB = app.firestore();
export const Storage = app.storage();
export const Realtime = firebase.database();
export const Analytics = app.analytics();
